export function optionsParser(item) {
  return {
    title: item.get(1),
    value: item.get(0),
  };
}

export function safeFloorParser(item){
  return {
    title: item.get('serial'),
    value: item.get('serial')
  };
}

export function eventsParser(item) {
  let value = item.get(1);
  const isSpaced = value.split(' ').length > 1;
  value = isSpaced ? value.split(' ')[1] : value;
  return {
    title: value,
    value: item.get(0),
  };
}

export function getOptionsTranslator(intl, messages) {
  return item => {
    item.title = intl.formatMessage({ ...messages[item.title] });
    return item;
  };
}


// WEBPACK FOOTER //
// ./src/core/utils.js